import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { teamApi } from "@/api/teamApi";

export const fetchTeams = createAsyncThunk("teams/fetchAll", () =>
  teamApi.list(),
);
export const createTeam = createAsyncThunk(
  "teams/create",
  (data: { name: string; description?: string }) => teamApi.create(data),
);
export const deleteTeam = createAsyncThunk("teams/delete", (id: string) =>
  teamApi.remove(id).then(() => id),
);

const teamSlice = createSlice({
  name: "teams",
  initialState: { list: [] as any[], loading: false },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchTeams.pending, (s) => {
      s.loading = true;
    })
      .addCase(fetchTeams.fulfilled, (s, a) => {
        s.list = a.payload;
        s.loading = false;
      })
      .addCase(fetchTeams.rejected, (s) => {
        s.loading = false;
      })
      .addCase(createTeam.fulfilled, (s, a) => {
        s.list.push(a.payload);
      })
      .addCase(deleteTeam.fulfilled, (s, a) => {
        s.list = s.list.filter((t: any) => t.id !== a.payload);
      });
  },
});

export default teamSlice.reducer;
